import { MARQUEE_ITEMS } from "../data/site";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      className="relative overflow-hidden border-y border-gold/15 bg-navy-900 py-7"
      data-testid="editorial-marquee"
    >
      <div className="animate-marquee flex w-max items-center">
        {[...items, ...items].map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="px-10 font-serif text-sm font-medium tracking-[0.35em] text-gold-brass/80 md:text-base">
              {item}
            </span>
            <span className="text-[0.6rem] text-gold/50">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
